var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashCanNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_bin_2956146") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Games/Questions-options",
    transform: "translate(-1100.000000, -546.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/TableBox",
    transform: "translate(340.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(50.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown-Options",
    transform: "translate(687.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-4",
    transform: "translate(0.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.77272727,11.9117647 C5.14560078,11.9117647 5.44934257,11.679669 5.45454545,11.3907095 L5.45454545,7.1460757 C5.45454545,6.85423262 5.14928506,6.61764706 4.77272727,6.61764706 C4.39616949,6.61764706 4.09090909,6.85423262 4.09090909,7.1460757 L4.09090909,11.3907095 C4.09611198,11.679669 4.39985376,11.9117647 4.77272727,11.9117647 L4.77272727,11.9117647 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,11.9117647 C7.87287351,11.9117647 8.1766153,11.679669 8.18181818,11.3907095 L8.18181818,7.1460757 C8.18181818,6.85423262 7.87655778,6.61764706 7.5,6.61764706 C7.12344222,6.61764706 6.81818182,6.85423262 6.81818182,7.1460757 L6.81818182,11.3907095 C6.8233847,11.679669 7.12712649,11.9117647 7.5,11.9117647 L7.5,11.9117647 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2272727,11.9117647 C10.6001462,11.9117647 10.903888,11.679669 10.9090909,11.3907095 L10.9090909,7.1460757 C10.9090909,6.85423262 10.6038305,6.61764706 10.2272727,6.61764706 C9.85071494,6.61764706 9.54545455,6.85423262 9.54545455,7.1460757 L9.54545455,11.3907095 C9.55065743,11.679669 9.85439922,11.9117647 10.2272727,11.9117647 L10.2272727,11.9117647 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4241071,2.66669829 L10.7383929,2.66669829 L10.2642857,1.14762808 C10.0487057,0.470082623 9.39766179,0.00518541011 8.65714286,0 L6.34553571,0 C5.60501678,0.00518541011 4.95397291,0.470082623 4.73839286,1.14762808 L4.26428571,2.66669829 L0.575892857,2.66669829 C0.257836015,2.66669829 0,2.9132815 0,3.21745731 C0,3.52163311 0.257836015,3.76821632 0.575892857,3.76821632 L1.26160714,3.76821632 L1.26160714,14.3709677 C1.26748819,15.2063395 1.97648753,15.8809655 2.85,15.8823529 L12.16875,15.8823529 C13.0453836,15.8809427 13.7556683,15.2016572 13.7571429,14.3632827 L13.7571429,3.75028463 L14.4241071,3.75028463 C14.742164,3.75028463 15,3.50370142 15,3.19952562 C14.9993405,3.05527293 14.9378415,2.9173784 14.8294334,2.8170771 C14.7210253,2.7167758 14.574882,2.66255565 14.4241071,2.66669829 Z M5.85267857,1.46271347 C5.91981633,1.25425351 6.11760274,1.1093037 6.34553571,1.10151803 L8.67321429,1.10151803 C8.90728207,1.09962588 9.11315817,1.24913669 9.17410714,1.46527514 L9.54375,2.66669829 L5.45357143,2.66669829 L5.85267857,1.46271347 Z M12.6053571,14.4836812 L12.5651786,14.4836812 C12.5037451,14.652263 12.3393062,14.7666355 12.1526786,14.7705882 L2.85,14.7705882 C2.60713343,14.766419 2.41212969,14.5776516 2.41071429,14.345351 L2.41071429,3.75028463 L12.6053571,3.75028463 L12.6053571,14.4836812 Z",
    id: "Shape"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanNew);
export default __webpack_public_path__ + "static/media/trash-can-new.97c8d845c9234bcb240f8fd6f17efd83.svg";
export { ForwardRef as ReactComponent };